import { Col, message, Row, Tabs, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    SelectItem,
    InputItem,
    ButtonItem,
    ErrorItem,
    InputNumberItem,
    TurnoGrid,
    SelectTiposDeJornadasSATItem,
} from "../../../../Components/Items";
import TextAreItem from "../../../../Components/TextAreaItem";

const { TabPane } = Tabs;
const { Option } = Select;

class AgregarTurno extends Component {
    formRef = React.createRef();
    state = {
        loading: false,

        // config del grid
        turnoConfig: {
            unidad: "semana",
            ciclos: 1,
            columnas: [
                { "key": "sun", "label": "Dom" },
                { "key": "mon", "label": "Lun" },
                { "key": "tue", "label": "Mar" },
                { "key": "wed", "label": "Mié" },
                { "key": "thu", "label": "Jue" },
                { "key": "fri", "label": "Vie" },
                { "key": "sat", "label": "Sáb" }
            ],
            grid: [
                { "r": 1, "c": "sun", "horarios": [] },
                { "r": 1, "c": "mon", "horarios": [] },
                { "r": 1, "c": "tue", "horarios": [] },
                { "r": 1, "c": "wed", "horarios": [] },
                { "r": 1, "c": "thu", "horarios": [] },
                { "r": 1, "c": "fri", "horarios": [] },
                { "r": 1, "c": "sat", "horarios": [] }
            ]
        }
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    cerrarAgregarTurno(codigo) {
        this.props.cerrarAgregarTurno(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });

        const payload = {
            ...values,
            empresaId: this.props.empresaId,

            // <- aquí va el grid completo
            turnoConfig: this.state.turnoConfig,
        };

        axios
            .post("turnos/agregarTurno", payload, { headers: this.props.headersToken })
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado un turno");
                    if (this.props.onGuardado) this.props.onGuardado();
                    this.formRef.current.resetFields();
                    this.cerrarAgregarTurno(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede registrar el turno");
                } else {
                    message.error("Hubo un error y el turno no se registro");
                }
            });
    }

    //Helpers grid

    buildColumns = (unidad) => {
        if (unidad === "semana") return [
            { key: "sun", label: "Dom" },
            { key: "mon", label: "Lun" },
            { key: "tue", label: "Mar" },
            { key: "wed", label: "Mié" },
            { key: "thu", label: "Jue" },
            { key: "fri", label: "Vie" },
            { key: "sat", label: "Sáb" },
        ];
        if (unidad === "dia") return [{ key: "d1", label: "Día" }];
        if (unidad === "mes") return Array.from({ length: 31 }, (_, i) => ({ key: `d${i + 1}`, label: `${i + 1}` }));
        if (unidad === "ciclo24") return Array.from({ length: 24 }, (_, i) => ({ key: `h${i + 1}`, label: `${i + 1}` }));
        if (unidad === "ciclo48") return Array.from({ length: 48 }, (_, i) => ({ key: `b${i + 1}`, label: `${i + 1}` }));
        return [];
    };

    buildEmptyGrid = (ciclos, columnas) => {
        const grid = [];
        for (let r = 1; r <= ciclos; r++) {
            for (const col of columnas) grid.push({ r, c: col.key, horarios: [] });
        }
        return grid;
    };

    getMaxCiclos = (unidad) => {
        if (unidad === "dia") return 366;
        if (unidad === "semana") return 52;
        if (unidad === "mes") return 12;
        return 52; // define tu regla para ciclo24/48
    };

    initTurnoConfig = (unidad = "semana", ciclos = 1) => {
        const columnas = this.buildColumns(unidad);
        const grid = this.buildEmptyGrid(ciclos, columnas);
        return { unidad, ciclos, columnas, grid };
    };

    setUnidad = (unidad) => {
        this.setState((prev) => {
            const max = this.getMaxCiclos(unidad);
            const ciclos = Math.min(prev.turnoConfig.ciclos || 1, max);
            return { turnoConfig: this.initTurnoConfig(unidad, ciclos) };
        });
    };

    setCiclos = (ciclos) => {
        this.setState((prev) => {
            const unidad = prev.turnoConfig.unidad;
            const max = this.getMaxCiclos(unidad);
            const safe = Math.max(1, Math.min(Number(ciclos || 1), max));
            return { turnoConfig: this.initTurnoConfig(unidad, safe) };
        });
    };

    onCellChange = ({ r, c, horarios }) => {
        this.setState((prev) => ({
            turnoConfig: {
                ...prev.turnoConfig,
                grid: prev.turnoConfig.grid.map((cell) =>
                    cell.r === r && cell.c === c ? { ...cell, horarios } : cell
                )
            }
        }));
    };

    render() {
        return (
            <>
                <ModalItem
                    title="Agregar Turno"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarAgregarTurno.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="agregarTurno"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Agregar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="Información general" key="1">
                                <FormItem
                                    name="nombre"
                                    label="Nombre"
                                    required
                                    max={100}
                                    margin
                                    pattern
                                >
                                    <InputItem placeholder="Nombre" />
                                </FormItem>
                                <FormItem
                                    name="descripcion"
                                    label="Descripción"
                                    margin
                                    pattern
                                >
                                    <TextAreItem
                                        placeholder="Descripción"
                                    />
                                </FormItem>
                                <FormItem
                                    name="horasTurno"
                                    label="Horas Turno"
                                    required
                                    margin
                                >
                                    <InputNumberItem placeholder="Horas Turno" min={1} max={24} />
                                </FormItem>
                                <FormItem
                                    label="Tipo de jornada"
                                    name="tipoJornadaSatId"
                                    margin
                                    required
                                >
                                    <SelectTiposDeJornadasSATItem
                                        placeholder="Tipo de jornada"
                                        empresaId={this.props.empresaId}
                                        headersToken={this.props.headersToken}
                                    />
                                </FormItem>
                            </TabPane>
                            <TabPane tab="Control de asistencia" key="2">
                                <Row gutter={12} style={{ marginBottom: 12 }}>
                                    <Col>
                                        <div style={{ fontWeight: 600, marginBottom: 4 }}>Unidad</div>
                                        <SelectItem
                                            style={{ width: 220 }}
                                            value={this.state.turnoConfig.unidad}
                                            onChange={this.setUnidad}
                                        >
                                            <Option value="dia">Día</Option>
                                            <Option value="semana">Semana</Option>
                                            <Option value="mes">Mes</Option>
                                            <Option value="ciclo24">Ciclo de 24 Horas</Option>
                                            <Option value="ciclo48">Ciclo de 48 Horas</Option>
                                        </SelectItem>
                                    </Col>

                                    <Col>
                                        <div style={{ fontWeight: 600, marginBottom: 4 }}>Ciclos</div>
                                        <InputNumberItem
                                            min={1}
                                            max={this.getMaxCiclos(this.state.turnoConfig.unidad)}
                                            value={this.state.turnoConfig.ciclos}
                                            onChange={this.setCiclos}
                                        />
                                    </Col>
                                </Row>

                                <TurnoGrid
                                    turno={this.state.turnoConfig}
                                    onCellChange={this.onCellChange}
                                    empresaId={this.props.empresaId}
                                    headersToken={this.props.headersToken}
                                />
                            </TabPane>
                        </Tabs>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarTurno);
